import {ROUTE_DETAILS, STOP_DETAILS, STOP_GROUP} from "../config/paths/apiPaths";
import mapMarkers from '../config/enum/mapMarkers';
import {saveHistory} from "../indexedDb/historyDb";

export default {
  namespaced: true,

  state: {
    routeDetails: {},
    stopDetails: {},
    stopGroup: {},
  },

  mutations: {
    setRouteDetails(state, routeDetails) {
      state.routeDetails = {
        ...routeDetails,
        stops: routeDetails.stops.filter(x => x.length > 0),
      };

    },
    setStopDetails(state, stopDetails) {
      state.stopDetails = stopDetails;

    },
    setStopGroup(state, stopGroup){
      state.stopGroup = stopGroup;
    },
  },

  actions: {
    getRouteDetails({commit}, routeId) {
      return fetch(`${ROUTE_DETAILS}/${routeId}`)
        .then(response => response.json())
        .then(json => {
          const {startc, destinc} = json.data;

          saveHistory({
            ...json.data,
            type: 'route-details',
          });

          commit('setRouteDetails', json.data);
          commit(
            'googleMap/setMarkers',
            json.data.stops
              .flat()
              .map(x => {

                return {
                  ...x,
                  position: {
                    lat: x.lat,
                    lng: x.lng,
                  },
                  startc, destinc,
                  markerIcon: x.routedir === 1
                    ? {url: mapMarkers.destincIcon}
                    : {url: mapMarkers.startcIcon},
                  infoWindowOpened: false,
                };
              }),
            {root: true}
          );

          return json.data;
        });

    },
    getStopDetails({commit}, stopId) {
      fetch(`${STOP_DETAILS}/${stopId}`)
        .then(response => response.json())
        .then(json => {
          commit('setStopDetails', json.data);
        });
    },
    getStopGroup({ commit }, stopGroupId){
      fetch(`${STOP_GROUP}/${stopGroupId}`)
        .then(response => response.json())
        .then(json => {
          commit('setStopGroup', json.data);
        });
    },
  },

  getters: {}

}
